package uz.ferro.shop.pages

enum class LinkType {
    EMAIL,
    PHONE,
    WEB,
    GEO
}